import { useFormStore, useConfigStore } from '@/features/form';
import HandleTabIndex from './HandleTabIndex';

export default function Branding() {
	const { branding } = useConfigStore();
	const { brandingRef } = useFormStore();
	return (
		<div>
			{branding ? (
				<span dangerouslySetInnerHTML={{ __html: branding }} />
			) : (
				<div
					id="branding"
					class="branding anim"
					style={{
						textAlign: 'center'
					}}
				>
					<HandleTabIndex
						ref={brandingRef}
						component="a"
						href="https://mopinion.com/form-referral-landing/?track=FormReferral"
						id="branding-link"
						target="_blank"
						class="center-branding"
						style={{ display: 'inline-block!important' }}
						aria-label="Powered by Mopinion"
						rel="noreferrer"
					>
						<span
							class="brand-text"
							lang="en"
							style={{ display: 'inline-block!important' }}
						>
							Powered by
						</span>

						<span
							class="brand-logo"
							style={{ display: 'inline-block!important' }}
						>
							<svg
								alt="Mopinion logo"
								xmlns="http://www.w3.org/2000/svg"
								style={{ display: 'inline-block!important', verticalAlign: 'middle' }}
								viewBox="0 0 462.51416 118.31606"
							>
								<path
									d="m 98.694152,16.190639 -81.63,-15.91 a 14.25,14.25 0 0 0 -16.99999968,15.32 L 8.2641523,105.30064 a 14.23,14.23 0 0 0 18.0799997,12.47 L 107.45415,95.160639 a 14.23,14.23 0 0 0 10.28,-15.88 l -7.66,-51.18 a 14.11,14.11 0 0 0 -11.409998,-11.91 z"
									style="fill:#c82027;fill-rule:evenodd"
								/>
								<path
									d="m 66.684152,86.010639 h -14.74 v -31.57 c 0,-3.89 -0.65,-6.82 -2,-8.77 -1.35,-1.95 -3.36,-2.92 -6.16,-2.92 q -5.66,0 -8.22,4.15 c -1.71,2.78 -2.56,7.33 -2.56,13.68 v 25.43 h -14.71 v -54 h 11.27 l 2,6.91 h 0.82 a 15.06,15.06 0 0 1 6.27,-5.91 20.39,20.39 0 0 1 9.42,-2.1 q 12.13,0 16.44,7.93 h 1.3 a 14.66,14.66 0 0 1 6.41,-5.83 21.3,21.3 0 0 1 9.55,-2.08 q 9.18,0 13.89,4.71 4.709998,4.71 4.719998,15.11 v 35.26 H 85.564152 v -31.57 c 0,-3.89 -0.65,-6.82 -2,-8.77 -1.35,-1.95 -3.36,-2.92 -6.17,-2.92 q -5.42,0 -8.09,3.86 -2.67,3.86 -2.69,12.28 z"
									style="fill:#ffffff"
								/>
								<g
									style="fill:#303031"
									transform="translate(-68.435848,-44.989361)"
								>
									<path d="m 243.8,103.9 q 0,13.23 -6.79,20.65 -6.79,7.42 -18.89,7.45 a 25.86,25.86 0 0 1 -13.38,-3.42 22.51,22.51 0 0 1 -8.94,-9.82 33.45,33.45 0 0 1 -3.12,-14.84 q 0,-13.14 6.73,-20.51 6.73,-7.37 19,-7.37 11.72,0 18.55,7.54 6.83,7.54 6.84,20.32 z m -39.31,0 q 0,18.7 13.82,18.7 13.66,0 13.67,-18.7 0,-18.51 -13.77,-18.51 -7.23,0 -10.47,4.79 -3.24,4.79 -3.25,13.72 z" />
									<path d="m 281.67,132 q -10.25,0 -15.91,-7.38 h -0.69 q 0.69,6.84 0.69,8.3 V 154 H 254.28 V 77 h 9.28 c 0.26,1 0.8,3.41 1.61,7.22 h 0.59 q 5.37,-8.2 16.11,-8.2 10.11,0 15.75,7.32 5.64,7.32 5.64,20.56 0,13.23 -5.74,20.65 -5.74,7.42 -15.85,7.45 z m -2.78,-46.59 q -6.84,0 -10,4 -3.16,4 -3.15,12.79 v 1.71 q 0,9.87 3.12,14.28 3.12,4.41 10.21,4.42 a 10.37,10.37 0 0 0 9.18,-4.88 c 2.15,-3.26 3.22,-7.89 3.22,-13.92 0,-6.03 -1.07,-10.63 -3.2,-13.74 a 10.66,10.66 0 0 0 -9.38,-4.68 z" />
									<path d="M 325.36,131 H 313.89 V 77 h 11.47 z m -5.85,-60.76 a 6.62,6.62 0 0 1 -6.62,-6.62 6.62,6.62 0 0 1 6.62,-6.62 6.61,6.61 0 0 1 6.61,6.62 6.62,6.62 0 0 1 -6.61,6.62 z" />
									<path d="M 386.58,131 H 375.05 V 97.8 c 0,-4.17 -0.83,-7.28 -2.51,-9.33 -1.68,-2.05 -4.34,-3.08 -8,-3.08 q -7.28,0 -10.65,4.3 -3.37,4.3 -3.37,14.41 V 131 H 339.07 V 77 h 9 l 1.61,7.08 h 0.59 a 16,16 0 0 1 6.93,-6 23.26,23.26 0 0 1 10,-2.1 q 19.44,0 19.44,19.77 z" />
									<path d="M 411.32,131 H 399.84 V 77 h 11.48 z m -5.9,-60.76 a 6.59,6.59 0 0 1 -6.58,-6.58 6.58,6.58 0 0 1 6.58,-6.58 6.57,6.57 0 0 1 6.58,6.58 6.58,6.58 0 0 1 -6.58,6.58 z" />
									<path d="m 472.93,103.9 q 0,13.23 -6.79,20.65 -6.79,7.42 -18.9,7.45 a 25.91,25.91 0 0 1 -13.38,-3.42 22.55,22.55 0 0 1 -8.93,-9.82 33.31,33.31 0 0 1 -3.13,-14.84 q 0,-13.14 6.74,-20.51 6.74,-7.37 19,-7.37 11.71,0 18.55,7.54 6.84,7.54 6.84,20.32 z m -39.31,0 q 0,18.7 13.82,18.7 13.67,0 13.67,-18.7 0,-18.51 -13.77,-18.51 -7.23,0 -10.47,4.79 -3.24,4.79 -3.25,13.72 z" />
									<path d="M 530.92,131 H 519.4 V 97.8 q 0,-6.26 -2.52,-9.33 -2.52,-3.07 -8,-3.08 -7.27,0 -10.65,4.3 -3.38,4.3 -3.37,14.41 V 131 H 483.41 V 77 h 9 l 1.59,7.08 h 0.59 a 16,16 0 0 1 6.93,-6 23.28,23.28 0 0 1 10,-2.1 q 19.43,0 19.43,19.77 z" />
								</g>
							</svg>
						</span>
					</HandleTabIndex>
				</div>
			)}
		</div>
	);
}
